import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "ticketFields",
    "disabledMessageField",
    "forwardingEnabledField",
    "disableTicketsForwardingEnabledSwitch",
  ];

  toggleAllOpenTicketsDisabled(event) {
    const isDisabled = event.target.value === "true";

    if (isDisabled) {
      this.ticketFieldsTarget.classList.add("hidden");
      this.disabledMessageFieldTarget.classList.remove("hidden");

      if (this.hasForwardingEnabledFieldTarget) {
        this.forwardingEnabledFieldTarget.classList.add("hidden");
        this.disableTicketsForwardingEnabledSwitchTarget.value = true;
      }
    } else {
      this.ticketFieldsTarget.classList.remove("hidden");
      this.disabledMessageFieldTarget.classList.add("hidden");

      if (this.hasForwardingEnabledFieldTarget) {
        this.forwardingEnabledFieldTarget.classList.remove("hidden");
      }
    }
  }
}
